module.exports = __webpack_public_path__ + "static/media/slotsCasinoPopUp.0b73a914.svg";